import React from "react";
import { Icon } from "@shopify/polaris";
import { LockIcon } from "@shopify/polaris-icons";

export default function PlanLockOverlay({ locked, onUnlock, children, label = "Upgrade to Pro to edit this" }) {
  if (!locked) return children;
  return (
    <div
      className="age-plan-lock age-plan-lock--on"
      role="link"
      tabIndex={0}
      aria-label={label}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onUnlock();
      }}
      onKeyDown={(event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        event.stopPropagation();
        onUnlock();
      }}
    >
      <div className="age-plan-lock__body">{children}</div>
      <div className="age-plan-lock__veil" aria-hidden>
        <span className="age-plan-lock__icon">
          <Icon source={LockIcon} />
        </span>
      </div>
    </div>
  );
}
